/**
 * <ix-shop-sheet> — mobile "Shop by category" bottom sheet.
 * Ported from the Interactive theme.
 *
 * Opens when any element matching the configurable `data-open-selectors`
 * (default: [data-open-shop-sheet], a[href="#shop-sheet"]) is clicked;
 * closes via the close button, the overlay, or Escape.
 */
class IxShopSheet extends HTMLElement {
  connectedCallback() {
    this.sheet = this.querySelector('.shop-sheet');
    this.overlay = this.querySelector('.shop-sheet__overlay');
    const selectors = this.dataset.openSelectors || '[data-open-shop-sheet], a[href="#shop-sheet"]';

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest(selectors);
      if (trigger) {
        event.preventDefault();
        this.open();
        return;
      }
    });

    this.querySelector('[data-shop-sheet-close]')?.addEventListener('click', () => this.close());
    this.overlay?.addEventListener('click', () => this.close());

    if (this.dataset.escClose === 'true') {
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.close();
      });
    }
  }

  open() {
    this.sheet?.classList.add('is-open');
    this.sheet?.setAttribute('aria-hidden', 'false');
    this.overlay?.classList.add('is-open');
    if (this.dataset.lockScroll === 'true') document.body.classList.add('shop-sheet-open');
  }

  close() {
    this.sheet?.classList.remove('is-open');
    this.sheet?.setAttribute('aria-hidden', 'true');
    this.overlay?.classList.remove('is-open');
    document.body.classList.remove('shop-sheet-open');
  }
}

if (!customElements.get('ix-shop-sheet')) {
  customElements.define('ix-shop-sheet', IxShopSheet);
}
